import { Link, useParams } from 'react-router-dom';
import categories from '../products';
import { useState, useEffect, useRef } from 'react';
import placeholderImg from '../images/logo_jm_simpel.png';

export default function Category() {
  const { id } = useParams();
  const category = categories.find(cat => cat.id === id);
  const [showColor, setShowColor] = useState(null);
  const [showImgModal, setShowImgModal] = useState(null); // {productIdx, imgIdx}
  const [carouselIdx, setCarouselIdx] = useState(category ? category.products.map(() => 0) : []);
  const plaColors = [
    { name: 'almont yellow', file: require('../PLA/almont yellow.jpg') },
    { name: 'dark grey', file: require('../PLA/dark grey.jpg') },
    { name: 'peach pink', file: require('../PLA/peach pink.jpg') },
    { name: 'mint green', file: require('../PLA/mint green.jpg') },
    { name: 'lake blue', file: require('../PLA/lake blue.jpg') },
    { name: 'milky white', file: require('../PLA/milky white.jpg') },
    { name: 'deep black', file: require('../PLA/deep black.jpg') },
  ];
  const [atBottom, setAtBottom] = useState(false);
  const containerRef = useRef(null);
  const gridRef = useRef(null);
  const [arrowStyle, setArrowStyle] = useState({ left: '50%', width: '100%', maxWidth: '900px', transform: 'translateX(-50%)' });
  const homeBtnRef = useRef(null);
  const [hideArrow, setHideArrow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      setAtBottom(scrollY + windowHeight >= docHeight - 10);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    function updateArrowStyle() {
      if (gridRef.current) {
        const rect = gridRef.current.getBoundingClientRect();
        setArrowStyle({
          left: rect.left + rect.width / 2 + window.scrollX,
          width: rect.width,
          maxWidth: rect.width,
          transform: 'translateX(-50%)',
        });
      }
    }
    updateArrowStyle();
    window.addEventListener('resize', updateArrowStyle);
    return () => window.removeEventListener('resize', updateArrowStyle);
  }, []);

  useEffect(() => {
    if (!homeBtnRef.current) return;
    const observer = new window.IntersectionObserver(
      ([entry]) => setHideArrow(entry.isIntersecting),
      { root: null, threshold: 0.1 }
    );
    observer.observe(homeBtnRef.current);
    return () => observer.disconnect();
  }, [homeBtnRef]);

  if (!category) return <div className="container-custom py-16">Categorie niet gevonden.</div>;

  return (
    <div className="min-h-screen bg-gray-50" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>
      <div className="container-custom section" ref={containerRef}>
        <h1 className="text-2xl sm:text-3xl font-extrabold mb-6 sm:mb-8 text-center text-accent1">{category.name}</h1>
        {/* Producten-carousel bovenaan */}
        {/* <CategoryProductCarousel products={category.products} /> */}
        <div className="flex flex-col md:flex-row gap-6 md:gap-8">
          {/* Producten grid */}
          <div className="flex-1 min-w-0">
            <div className="grid grid-cols-1 gap-6" ref={gridRef}>
              {category.products.map((product, idx) => {
                const images = product.images && product.images.length > 0 ? product.images : [placeholderImg];
                const current = carouselIdx[idx] || 0;
                // Afmetingen als array of string
                let dimensionsList = null;
                if (Array.isArray(product.dimensions)) {
                  dimensionsList = (
                    <ul className="mb-2 text-sm text-gray-500 list-disc list-inside">
                      {product.dimensions.map((dim, i) => <li key={i}>{dim}</li>)}
                    </ul>
                  );
                } else if (typeof product.dimensions === 'string') {
                  dimensionsList = <div className="mb-2 text-sm text-gray-500">Afmetingen: {product.dimensions}</div>;
                }
                // Gestructureerde data voor SEO
                const jsonLd = {
                  '@context': 'https://schema.org/',
                  '@type': 'Product',
                  name: product.name,
                  description: product.description,
                  image: images[0],
                  offers: {
                    '@type': 'Offer',
                    availability: 'https://schema.org/InStock',
                    url: window.location.href,
                  },
                  additionalProperty: [
                    { '@type': 'PropertyValue', name: 'Levertijd', value: 'circa 5 werkdagen' },
                    ...(Array.isArray(product.dimensions)
                      ? product.dimensions.map(dim => ({ '@type': 'PropertyValue', name: 'Afmeting', value: dim }))
                      : product.dimensions ? [{ '@type': 'PropertyValue', name: 'Afmeting', value: product.dimensions }] : []),
                  ],
                };
                return (
                  <div key={idx} className="card flex flex-col items-center text-center bg-white rounded-xl shadow p-4 sm:p-8" style={{ minHeight: 320, minWidth: 0, maxWidth: 440, margin: '0 auto', overflow: 'hidden' }}>
                    {/* SEO structured data */}
                    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
                    {/* Carousel met fotoboek-effect */}
                    <div className="relative flex items-center justify-center w-full mb-4" style={{ height: 180 }}>
                      {/* Vorige knop */}
                      {images.length > 1 && (
                        <button
                          className="absolute left-0 z-10 bg-white/80 hover:bg-accent1 text-accent1 hover:text-white rounded-full p-2 shadow transition"
                          style={{ top: '50%', transform: 'translateY(-50%)' }}
                          onClick={e => {
                            e.stopPropagation();
                            setCarouselIdx(arr => arr.map((v, i) => i === idx ? (v - 1 + images.length) % images.length : v));
                          }}
                          aria-label="Vorige afbeelding"
                        >
                          <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 19l-7-7 7-7" /></svg>
                        </button>
                      )}
                      <div className="flex items-center justify-center overflow-visible w-full" style={{ maxWidth: 320, position: 'relative' }}>
                        {images.map((img, i) => {
                          const diff = i - current;
                          if (Math.abs(diff) > 1) return null;
                          // Hoofdafbeelding altijd exact in het midden
                          let style = {};
                          if (diff === -1) style = { position: 'absolute', left: 'calc(50% - 120px)', zIndex: 0 };
                          if (diff === 1) style = { position: 'absolute', right: 'calc(50% - 120px)', zIndex: 0 };
                          if (diff === 0) style = { position: 'relative', zIndex: 10, margin: '0 auto' };
                          return (
                            <img
                              key={i}
                              src={img}
                              alt={product.name}
                              className={`object-contain rounded shadow transition-all duration-300 ${diff === 0 ? 'scale-105 w-[180px] h-[180px] sm:w-[340px] sm:h-[340px]' : 'scale-90 w-[80px] h-[100px] sm:w-[140px] sm:h-[180px] opacity-70 cursor-pointer'}`}
                              style={style}
                              onClick={e => {
                                e.stopPropagation();
                                setCarouselIdx(arr => arr.map((v, j) => j === idx ? i : v));
                              }}
                              ref={el => { if (el) console.log('Productgrid img:', img); }}
                            />
                          );
                        })}
                      </div>
                      {/* Volgende knop */}
                      {images.length > 1 && (
                        <button
                          className="absolute right-0 z-10 bg-white/80 hover:bg-accent1 text-accent1 hover:text-white rounded-full p-2 shadow transition"
                          style={{ top: '50%', transform: 'translateY(-50%)' }}
                          onClick={e => {
                            e.stopPropagation();
                            setCarouselIdx(arr => arr.map((v, i) => i === idx ? (v + 1) % images.length : v));
                          }}
                          aria-label="Volgende afbeelding"
                        >
                          <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" /></svg>
                        </button>
                      )}
                    </div>
                    <h2 className="text-xl font-bold mb-2 text-accent1">{product.name}</h2>
                    {product.price && (
                      <div className="mb-2 text-lg font-semibold text-accent2">Prijs vanaf €{product.price}</div>
                    )}
                    <div style={{ height: '1rem' }} />
                    {/* Beschrijving als array van alinea's of enkele string */}
                    {Array.isArray(product.description)
                      ? product.description.map((para, i) => <p key={i} className="mb-2 text-base">{para}</p>)
                      : product.description && <p className="mb-2 text-base">{product.description}</p>
                    }
                    {dimensionsList}
                    <div className="mb-2 text-sm text-gray-500">Levertijd: circa 5 werkdagen</div>
                    <Link to={product.contactLink} className="btn-primary px-6 py-3 text-lg mt-auto w-full">Vraag aan</Link>
                  </div>
                );
              })}
            </div>
            <div className="container-custom mt-8 text-center">
              <Link to="/" className="text-accent1 hover:underline" ref={homeBtnRef}>← Terug naar Home</Link>
            </div>
          </div>
          {/* PLA kleuren zijbalk helemaal rechts */}
          <div className="md:ml-6 ml-0 w-full md:w-64 flex-shrink-0 card h-fit md:sticky md:top-32" style={{ alignSelf: 'flex-start' }}>
            <h3 className="text-lg font-bold mb-2 text-accent1">Beschikbare PLA kleuren</h3>
            <div className="flex flex-wrap gap-4 items-center mb-2">
              {plaColors.map((color, idx) => (
                <div key={color.name} className="flex flex-col items-center cursor-pointer" onClick={() => setShowColor(idx)}>
                  <img src={color.file} alt={color.name} className="w-10 h-10 object-cover rounded shadow border border-grey hover:scale-110 transition" />
                  <span className="text-xs mt-1 text-gray-700">{color.name}</span>
                </div>
              ))}
            </div>
            <div className="text-sm text-gray-500 mt-2">Andere kleuren zijn mogelijk op aanvraag.</div>
          </div>
        </div>
        {/* Lightbox/modal voor grote kleurweergave */}
        {showColor !== null && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60" onClick={() => setShowColor(null)}>
            <div className="bg-white rounded-xl p-4 shadow-lg max-w-xs flex flex-col items-center">
              <img src={plaColors[showColor].file} alt={plaColors[showColor].name} className="w-64 h-64 object-contain rounded mb-2" />
              <div className="text-base font-semibold text-accent1 mb-2">{plaColors[showColor].name}</div>
              <button className="btn-secondary mt-2" onClick={() => setShowColor(null)}>Sluiten</button>
            </div>
          </div>
        )}
        {/* Modal voor grote afbeelding + carousel */}
        {showImgModal && (
          <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-30" onClick={() => setShowImgModal(null)}>
            <div
              className="relative bg-white rounded-xl shadow-lg flex flex-col items-center p-6"
              style={{ maxWidth: '900px', minWidth: '60vw', minHeight: '400px' }}
              onClick={e => e.stopPropagation()}
            >
              <button className="absolute top-2 right-2 btn-secondary" onClick={() => setShowImgModal(null)}>Sluiten</button>
              <div className="relative flex items-center w-full justify-center" style={{ minHeight: '350px' }}>
                {/* Vorige knop */}
                {category.products[showImgModal.productIdx].images.length > 1 && (
                  <button
                    className="absolute left-0 z-10 bg-white/80 hover:bg-accent1 text-accent1 hover:text-white rounded-full p-2 shadow transition"
                    style={{ top: '50%', transform: 'translateY(-50%)' }}
                    onClick={() => setShowImgModal({
                      productIdx: showImgModal.productIdx,
                      imgIdx: (showImgModal.imgIdx - 1 + category.products[showImgModal.productIdx].images.length) % category.products[showImgModal.productIdx].images.length
                    })}
                    aria-label="Vorige afbeelding"
                  >
                    <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 19l-7-7 7-7" /></svg>
                  </button>
                )}
                {/* Carousel met fotoboek-effect */}
                <div className="flex items-center justify-center overflow-visible w-full" style={{ maxWidth: '700px' }}>
                  {category.products[showImgModal.productIdx].images.map((img, i) => {
                    // Toon alleen de vorige, huidige en volgende afbeelding (voor performance)
                    const diff = i - showImgModal.imgIdx;
                    if (Math.abs(diff) > 1) return null;
                    return (
                      <img
                        key={i}
                        src={img}
                        alt={category.products[showImgModal.productIdx].name}
                        className={`object-contain rounded shadow transition-all duration-300 ${diff === 0 ? 'z-10 scale-105 w-[400px] h-[350px]' : 'z-0 scale-90 w-[180px] h-[200px] opacity-70 cursor-pointer'}`}
                        style={{ marginLeft: diff === -1 ? '-60px' : 0, marginRight: diff === 1 ? '-60px' : 0 }}
                        onClick={() => setShowImgModal({ productIdx: showImgModal.productIdx, imgIdx: i })}
                        ref={el => { if (el) console.log('Modal img:', img); }}
                      />
                    );
                  })}
                </div>
                {/* Volgende knop */}
                {category.products[showImgModal.productIdx].images.length > 1 && (
                  <button
                    className="absolute right-0 z-10 bg-white/80 hover:bg-accent1 text-accent1 hover:text-white rounded-full p-2 shadow transition"
                    style={{ top: '50%', transform: 'translateY(-50%)' }}
                    onClick={() => setShowImgModal({
                      productIdx: showImgModal.productIdx,
                      imgIdx: (showImgModal.imgIdx + 1) % category.products[showImgModal.productIdx].images.length
                    })}
                    aria-label="Volgende afbeelding"
                  >
                    <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" /></svg>
                  </button>
                )}
              </div>
              {/* Carousel dots */}
              <div className="flex gap-2 mt-4">
                {category.products[showImgModal.productIdx].images.map((img, i) => (
                  <button
                    key={i}
                    className={`w-3 h-3 rounded-full border-2 ${showImgModal.imgIdx === i ? 'border-accent1 bg-accent1' : 'border-grey bg-grey'} transition`}
                    onClick={() => setShowImgModal({ productIdx: showImgModal.productIdx, imgIdx: i })}
                    aria-label={`Toon afbeelding ${i + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Knipperend, springend pijltje onderaan het scherm als je niet helemaal beneden bent */}
      {!atBottom && !hideArrow && (
        <div className="fixed bottom-8 z-50 flex justify-center pointer-events-none select-none" style={{ left: arrowStyle.left, width: arrowStyle.width, maxWidth: arrowStyle.maxWidth, transform: arrowStyle.transform, transition: 'left 0.2s, width 0.2s' }}>
          <span className="animate-bounce-blink text-accent1 text-6xl opacity-80 drop-shadow-lg">↓</span>
          <style>{`
            @keyframes bounce-blink {
              0%, 100% { opacity: 0.2; transform: translateY(0); }
              20% { opacity: 1; transform: translateY(-10px); }
              40% { opacity: 1; transform: translateY(0); }
              60% { opacity: 1; transform: translateY(-18px); }
              80% { opacity: 1; transform: translateY(0); }
            }
            .animate-bounce-blink {
              animation: bounce-blink 2.5s infinite;
            }
          `}</style>
        </div>
      )}
    </div>
  );
} 